import { GetCommentaryPresenter } from '@/presentation/presenters/commentary/getCommentaryPresenter'
import { GetCommentaryViewModel } from '@/presentation/viewmodels/commentary/getCommentaryViewModel'

export function useGetCommentaryPresenter(
  presenter: GetCommentaryPresenter = new GetCommentaryPresenter(new GetCommentaryViewModel())
) {
  return {
    isLoading: presenter.isLoading,
    error: presenter.error,
    getCommentary: presenter.getCommentary.bind(presenter)
  }
}
